import React from 'react';

import CompositionManager from 'components/customer/composition_manager';
import ConversationAssignment from 'components/customer/conversation_history/conversation_assignment';
import ConversationTopics from 'components/customer/conversation_topics';
import WorkflowButtons from 'components/customer/workflow_buttons';

const CustomerFooter = () => {
  return (
    <div className="customerV2-footer">
      <ConversationAssignment />
      <CompositionManager />
      <ConversationTopics />
      <WorkflowButtons />
    </div>
  );
};

export default React.memo(CustomerFooter);
